export const EMemCacheType = {
  "1": "FMT",
  "2": "COUNTRY",
  "4": "AIRPORT",
  "5": "AIRLINE",
  "6": "FLIGHT_SEARCH_RULE",
  "7": "FLIGHT_PROVIDER_FEATURES",
  "8": "RUNTIME_PARAMS",
  "9": "ATPCO",
  "10": "BOARD_TYPE",
  "11": "FACILITY",
  "12": "FLIGHT_COMMISSION_RULE",
  "13": "PROVIDER_CHANNELS",
  "14": "GSA",
  "15": "AGENCY",
  "16": "HOTEL_COMMISSION_RULE",
  "17": "HOTEL_MARKET",
  "18": "HOTEL_CANCELLATION_POLICY",
  "19": "HOTEL_PROVIDER_UPTIME",
  "20": "HOTEL_SEARCH_RULE",
  "21": "HOTEL_ADD_ON",
  "22": "HOTEL_CLOSED",
  "23": "HOTEL_PARTIAL_PAYMENT",
  "24": "HOTEL_ON_US_LIST",
  "25": "HOTEL_SPO_LIST",
  "26": "HOTEL_MARKUP_LIST",
  "27": "PROVIDERS",
  "28": "HOTEL_CHANNEL_SEARCH_CACHE"
};